export function startOfDay(date) {
  const year = date.getFullYear();
  const month = date.getMonth();
  const day = date.getDate();
  return new Date(year, month, day, 0, 0, 0);
}

export function formateDate(date) {
  const year = date.getFullYear();
  const month = date.getMonth() + 1;
  const day = date.getDate();
  return `${year}-${month}-${day}`;
}

export function addDay(date, offset) {
  // eslint-disable-next-line no-mixed-operators
  return new Date((+date) + offset * 24 * 60 * 60 * 1000);
}

export function formatDuration(duration) {
  const time = parseInt(duration / 1000, 10);
  let seconds = 0;
  let minutes = 0;
  let hours = 0;
  if (time) {
    if (time > 60 && time < 60 * 60) {
      minutes = parseInt(time / 60, 10);
      seconds = parseInt(time - minutes * 60, 10);
    } else if (time >= 60 * 60) {
      hours = parseInt(time / 60 / 60, 10);
      minutes = parseInt(time / 60, 10) - hours * 60;
      seconds = time - hours * 60 * 60 - minutes * 60;
    } else {
      seconds = time;
    }
  }
  if (hours < 10) {
    hours = `0${hours}`;
  }
  if (minutes < 10) {
    minutes = `0${minutes}`;
  }
  if (seconds < 10) {
    seconds = `0${seconds}`;
  }
  return {
    hours: String(hours),
    minutes: String(minutes),
    seconds: String(seconds),
  };
}

// 13位时间戳精准到毫秒
export function getCountdown(timestamp) {
  const now = Date.now();
  let diff = timestamp - now;

  if (diff < 0) {
    return {
      days: 0,
      hours: 0,
      minutes: 0,
      seconds: 0,
      milliseconds: 0,
      show: false,
    };
  }

  let milliseconds = diff % 1000;
  diff = (diff - milliseconds) / 1000;
  if (milliseconds < 100 && milliseconds > 10) {
    milliseconds = `0${milliseconds}`;
  }
  if (milliseconds < 10) {
    milliseconds = `00${milliseconds}`;
  }

  let seconds = diff % 60;
  diff = (diff - seconds) / 60;
  if (seconds < 10) {
    seconds = `0${seconds}`;
  }

  let minutes = diff % 60;
  diff = (diff - minutes) / 60;
  if (minutes < 10) {
    minutes = `0${minutes}`;
  }

  let hours = diff % 24;
  if (hours < 10) {
    hours = `0${hours}`;
  }
  const days = (diff - hours) / 24;

  return {
    days,
    hours,
    minutes,
    seconds,
    milliseconds,
    show: true,
  };
}
